import styled from 'styled-components';
import { RiArrowUpSLine } from 'react-icons/ri';

export const DboardSideMenuContainer = styled.nav.attrs({ id: 'dboard-side-nav' })`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  z-index: ${({ showMobileSideMenu }) => (showMobileSideMenu ? '100' : '-10')};
  &::-webkit-scrollbar {
    display: none;
  }
  @media (min-width: 992px) {
    position: sticky;
    max-width: ${({ showLandscapeSideMenu }) => (showLandscapeSideMenu ? 'var(--dboardSideNavWidth)' : '54px')};
    z-index: 10;
    background-color: ${(props) => props.theme.pageBg};
    border-right: 1px solid ${(props) => props.theme.borderColor};
  }
  &::-webkit-scrollbar {
    width: 4px;
    display: block;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
  }
  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => (props.darkTheme ? '#ffffff1a' : '#d2e3ff')};
  }
`;

export const SideMenuOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0px;
  transition: var(--layoutTransitionDuration);
  z-index: ${({ show }) => (show ? '0' : '-10')};
  background: ${(props) => (props.show ? '#000000a1' : 'transparent')};
  @media (min-width: 992px) {
    display: none;
  }
`;

export const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  transition: var(--layoutTransitionDuration);
`;

export const SideMenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  transition: var(--layoutTransitionDuration);
`;

export const SideMenuItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  padding: var(--dboardSideNavPadding);
  font-weight: ${(props) => props.active && 600};
  color: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
  background: ${(props) => (props.active ? '#2575fc2e' : props.theme.pageBg)};
  cursor: pointer;
  overflow: hidden;
  &:hover {
    background: ${(props) => !props.active && props.theme.selectionBg};
  }
`;

export const SideMenuIcon = styled.div`
  width: var(--dboardSideMenuIconSize);
  min-width: var(--dboardSideMenuIconSize);
  height: var(--dboardSideMenuIconSize);
  line-height: normal;
  & svg {
    width: 100%;
    height: 100%;
  }
  & svg .dboard-nofill {
    fill: none;
  }
  & svg .dboard-nofill-stroke {
    fill: none;
    stroke: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
  }
  & svg .dboard-fill {
    fill: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
  }
  & svg .dboard-fill-stroke {
    fill: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
    stroke: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
  }
`;

export const SideMenuItemText = styled.span`
  font-size: 15px;
  margin-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SideMenuRightIcon = styled.div`
  display: flex;
  font-size: 20px;
  color: ${({ darkTheme }) => (darkTheme ? '#d1d1d1' : 'var(--darkGreyTxtColor)')};
  margin-left: 4px;
  line-height: normal;
  transform: ${({ active }) => active && 'rotate(180deg)'};
  transition: transform var(--hoverTransitionDuration);
`;

export const SideMenuSecondaryDivision = styled.div``;

export const SideMenuSecondaryItem = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--dboardSideNavPadding);
  color: ${(props) => (props.active ? 'var(--brandColor)' : props.theme.txtIntense)};
  background: ${(props) => (props.active ? '#2575fc2e' : props.theme.pageBg)};
  cursor: pointer;
  overflow: hidden;
  &:hover {
    background: ${(props) => props.theme.selectionBg};
  }
`;

// SideNav UserInfo styles starts
export const UserCtaContainer = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;
  max-width: var(--dboardSideNavWidth);
  height: var(--dboardUserSettingsHeight);
  padding: 8px;
  background-color: ${(props) => props.theme.pageBg};
  border-top: 1px solid ${({ darkTheme }) => (darkTheme ? 'var(--inputTxtColor)' : '#0000001a')};
  @media (min-width: 992px) {
    border-right: 1px solid ${(props) => props.theme.borderColor};
  }
`;

export const UserInfoToggle = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: var(--dboardUserSettingsBtn);
  padding: 4px 8px;
  border-radius: var(--buttonRadius);
  background-color: ${(props) => props.active && props.theme.selectionBg};
  cursor: pointer;
  outline: none;
  transition: padding var(--layoutTransitionDuration);
  &:hover {
    transition: 0.4s;
    outline: none;
    background-color: ${(props) => props.theme.selectionBg};
  }
`;

export const UserInfoTextDiv = styled.div`
  overflow: hidden;
  margin-left: 8px;
`;

export const UserOptionsWrapper = styled.div`
  position: absolute;
  bottom: var(--dboardUserSettingsHeight);
  left: 0px;
  width: 100%;
  padding: 6px 0px;
  border-radius: var(--buttonRadius);
  background-color: ${(props) => props.theme.pageBg};
  border: 1px solid ${(props) => props.theme.borderColor};
  z-index: 5;
`;

export const UserInfoUserPicture = styled.img`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  transition: var(--layoutTransitionDuration);
`;

export const UserInfoUserName = styled.p`
  padding-bottom: 2px;
  font-size: 15px;
  font-family: var(--headingFont);
  font-weight: 500;
  line-height: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.theme.txtIntense};
`;

export const UserInfoUserMail = styled.p`
  font-size: 12px;
  font-family: var(--headingFont);
  line-height: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${(props) => props.theme.txtSecondary};
`;

export const UserInfoDropIcon = styled(RiArrowUpSLine)`
  font-size: 20px;
  color: ${(props) => props.theme.txtSecondary};
  margin-left: 4px;
  transform: ${({ active }) => active && 'rotate(180deg)'};
  transition: transform var(--hoverTransitionDuration);
`;

export const UserOptionDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.borderColor};
  }
  &:active {
    background-color: ${(props) => props.theme.selectionBg};
  }
`;

export const UserOptionIcon = styled.div`
  width: 18px;
  height: 18px;
  margin-right: 15px;
  line-height: normal;
  color: ${(props) => props.theme.txtPrimary};
  & svg {
    width: 100%;
    height: 100%;
  }
`;

export const UserOptionDivText = styled.p`
  line-height: normal;
  color: ${(props) => props.theme.txtPrimary};
`;
// SideNav UserInfo styles ends

export const DboardSideMenuWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: var(--dboardSideNavWidth);
  height: 100%;
  padding-top: var(--headerHeight);
  padding-bottom: var(--dboardUserSettingsHeight);
  left: ${({ showMobileSideMenu }) => (showMobileSideMenu ? '0%' : 'var(--dboardSideMenuNegativeWidth)')};
  z-index: 1;
  background-color: ${(props) => props.theme.pageBg};
  box-shadow: 1px 0px 0px ${({ darkTheme }) => (darkTheme ? 'var(--inputTxtColor)' : '#0000001a')};
  transition: left var(--layoutTransitionDuration);
  @media (min-width: 992px) {
    left: 0%;
    box-shadow: none;
    ${SideMenuWrapper} {
      align-items: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'flex-end'};
    }
    ${UserInfoToggle} {
      padding: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && '4px 0px'};
      background: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'none'};
    }
    ${UserInfoUserPicture} {
      width: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'var(--dboardClosedBtnHeight)'};
      height: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'var(--dboardClosedBtnHeight)'};
    }
    ${UserInfoTextDiv} {
      display: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'none'};
    }
    ${UserInfoDropIcon} {
      display: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'none'};
    }
    ${UserOptionsWrapper} {
      position: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && 'fixed'};
      left: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && '65px'};
      max-width: ${({ showLandscapeSideMenu }) => !showLandscapeSideMenu && '200px'};
    }
  }
`;
